import {
  getWarehouseValuesSummaryToday,
  getAllSalesItems,
  getCampaignReportSalesItemsThisMonth,
  getSalesItemPricesBySku,
  returnToCustomer
} from "src/core/api/apiRequests";
import useResponse from "src/core/api/useResponse";

// Warehouse reports
export const useGetWarehouseValuesSummary = () => {
    const { rows: response } = useResponse<any[]>({
        requestFunction: getWarehouseValuesSummaryToday,
    });
    return response;
}

// Campaign reports
interface ReportResponse {
    ReportRows: any[],
    ReportHeader: any,
}

export const useGetSalesItemPricesBySku = (sku) => {
    return useResponse<any[]>({requestFunction:getSalesItemPricesBySku,values:{sku}, requestNothingOnNull:true, dependency: sku});
    
}

export const useGetCampaignReportSalesItems = () => {
    const { rows: response } = useResponse<ReportResponse>({
        requestFunction: getCampaignReportSalesItemsThisMonth,
    });
    let idResponse = [];
    if (response != undefined) {
        if (response?.ReportRows?.length > 0) {
            response?.ReportRows?.forEach((item, i) => {
                const id = { Id: i + 1 }
                const newItem = Object.assign(item, id);
                idResponse.push(newItem)
            });
        } else {
            return  [undefined, undefined];
        }
    } else {
        return [undefined, undefined];
    }
    return [idResponse, response.ReportHeader];
}
